import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { successMessage: String, errorMessage: String }

  submit(event) {
    const form = event.target.closest("form")
    const formData = new FormData(form)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const checkbox = event.target.type === "checkbox" ? event.target : null
    const row = checkbox ? checkbox.closest("tr") : null

    // Optimistic row opacity toggle for checkboxes
    if (row) {
      row.classList.toggle("opacity-50", !checkbox.checked)
    }

    fetch(form.action, {
      method: form.method || "POST",
      body: formData,
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken
      },
      credentials: "same-origin"
    }).then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok")
      }

      if (this.successMessageValue) {
        this.showFlash(form, this.successMessageValue, "text-green-600")
      }
    }).catch(error => {
      console.error("Error:", error)

      // Revert checkbox and row opacity on failure
      if (checkbox && row) {
        checkbox.checked = !checkbox.checked
        row.classList.toggle("opacity-50", !checkbox.checked)
      }

      const errorMsg = this.errorMessageValue || "Failed to save settings"
      this.showFlash(form, errorMsg, "text-red-600")
    })
  }

  showFlash(form, message, colorClass) {
    const existingFlash = form.querySelector(".flash-message")
    if (existingFlash) {
      existingFlash.remove()
    }

    const flash = document.createElement("div")
    flash.className = `mt-2 text-sm ${colorClass} flash-message`
    flash.textContent = message
    form.appendChild(flash)

    setTimeout(() => {
      flash.remove()
    }, 3000)
  }
}
